// Fortschritt der Lieferung für die Sidebar (2026-10-03): wie viele Assets
// haben mindestens eine vollständige Version? „Geliefert" ist bewusst nicht
// der Sidebar-Status `uploaded` (der kippt zurück auf den gelben Punkt,
// sobald nach dem Upload ein neuer Favorit gesetzt wird) — für die Frage
// „habe ich schon alles abgegeben?" zählt, ob TRO etwas von diesem Asset hat.

export interface DeliveryProgress {
  done: number;
  total: number;
  /** 0..1, 0 bei leerer Liste. */
  ratio: number;
}

export function deliveryProgress(items: ReadonlyArray<{ delivered: boolean }>): DeliveryProgress {
  const total = items.length;
  const done = items.reduce((n, it) => n + (it.delivered ? 1 : 0), 0);
  return { done, total, ratio: total === 0 ? 0 : done / total };
}
